import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { CustomCheckBox, Image } from "hesus-ui-kit";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { daysOptions } from "@utils/filterOptions";
import addIcon from "@icons/ic-add-green.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import errorIcon from "@icons/ic-error.svg";
import "./AddEditWorkingHours.scss";
import {
  GridRow,
  MarginTop,
  ContainerLabel,
  ErrorDiv,
  MarginBottom,
} from "./AddEditWorkingHours.styled";

import { RequiredMessage } from "@utils/extra-style";

const AddEditWorkingHours = (props) => {
  const {
    t,
    inputList,
    inputListError,
    setInputList,
    setInputListError,
    workingHours,
    requiredTimeData,
    setRequiredTimeData,
  } = props;

  useEffect(() => {
    if (workingHours.length > 0) {
      const workingHoursList = Object.entries(workingHours).map(
        (workingHour, index) => {
          return {
            id: workingHour[1].id,
            openingTime: dayjs("0000-00-00T" + workingHour[1].openingHour),
            closingTime: dayjs("0000-00-00T" + workingHour[1].closingHour),
            days: workingHour[1].selectedDays
              ? workingHour[1].selectedDays.split(",")
              : [],
          };
        }
      );
      setInputList(workingHoursList);

      const workingHoursListError = Object.entries(workingHours).map(
        (workingHour) => {
          return {
            timeError: "",
          };
        }
      );
      setInputListError(workingHoursListError);
    }
  }, []);

  const onTimeChange = (value, index, name, errorName) => {
    const list = [...inputList];
    const listError = [...inputListError];

    if (name === "openingTime" || name === "closingTime") {
      list[index][name] = value;
      listError[index][errorName] = "";
    }
    setInputList(list);
    setInputListError(listError);
  };

  const onDaysSelect = (e, index, name, errorName, dayId) => {
    const list = [...inputList];
    const listError = [...inputListError];
    const tempTypeData = list[index][name];
    if (tempTypeData.indexOf(dayId) === -1 && e.currentTarget.checked) {
      list[index][name].push(dayId);
      listError[index][errorName] = "";
    } else {
      const dayIndex = list[index][name].indexOf(dayId);
      if (dayIndex >= 0) {
        list[index][name].splice(dayIndex, 1);
      }
    }
    setInputList(list);
    setInputListError(listError);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([
      ...inputList,
      {
        id: "",
        openingTime: dayjs("0000-00-00T07:00"),
        closingTime: dayjs("0000-00-00T16:00"),
        days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      },
    ]);
    setInputListError([
      ...inputListError,
      {
        timeError: "",
      },
    ]);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);

    const listError = [...inputListError];
    listError.splice(index, 1);
    setInputListError(listError);
  };

  useEffect(() => {
    setRequiredTimeData("");
  }, [inputList]);

  return (
    <>
      <MarginBottom>
        <ContainerLabel
          htmlFor="container-meeting-summary"
          color={requiredTimeData ? "red" : "#1bace4"}
        >
          {t("WORKING_HOURS")}
          <Image
            src={addIcon}
            alt="ADD_WORKING_HOURS"
            onClick={handleAddClick}
            className="workingHour__add-icon"
          />
        </ContainerLabel>
        {requiredTimeData === "COMPANY_ERROR_MISSING_WORKING_HOURS" && (
          <GridRow column="1fr">
            <ErrorDiv>
              <RequiredMessage maxWidth="auto">
                <Image
                  src={errorIcon}
                  alt="warning"
                  className="workingHour__error-icon"
                />{" "}
                {t(requiredTimeData)}
              </RequiredMessage>
            </ErrorDiv>
          </GridRow>
        )}
        {inputList.map((x, i) => {
          return (
            <React.Fragment key={"working-hours-main-" + i}>
              <GridRow column="2rem 6rem 1rem 6rem 1fr 1fr 1fr 1fr 1fr 1fr">
                <Image
                  src={deleteIcon}
                  alt={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_REMOVE")}
                  title={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_REMOVE")}
                  onClick={() => handleRemoveClick(i)}
                  className="workingHour__image-icon"
                />
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  localeText={{
                    clearButtonLabel: t("CANCEL"),
                    okButtonLabel: t("OK"),
                  }}
                >
                  <MobileTimePicker
                    className="workingHour__time_input"
                    openTo="hours"
                    value={x.openingTime}
                    onChange={(newValue) => {
                      onTimeChange(newValue, i, "openingTime", "timeError");
                    }}
                  />{" "}
                  <MarginTop>{t("TO")}</MarginTop>
                  <MobileTimePicker
                    className="workingHour__time_input"
                    openTo="hours"
                    value={x.closingTime}
                    onChange={(newValue) => {
                      onTimeChange(newValue, i, "closingTime", "timeError");
                    }}
                  />{" "}
                </LocalizationProvider>

                {daysOptions.map((day, index) => (
                  <MarginTop
                    key={"working-hours-days-" + index + i}
                    id={"working-hours-days-" + index + i}
                  >
                    <CustomCheckBox
                      className="workingHour__days_input"
                      key={`${day.name}`}
                      id={day.id + "==" + i}
                      labelText={t(day.name)}
                      dataId={day.id}
                      // checked={JSON.parse(typeData).indexOf(day.id) !== -1}
                      checked={x.days.indexOf(day.id) !== -1}
                      onChange={(e) => {
                        onDaysSelect(e, i, "days", "timeError", day.id);
                      }}
                    />
                  </MarginTop>
                ))}
              </GridRow>
              {inputListError[i].timeError !== "" && (
                <GridRow column="1fr">
                  <ErrorDiv>
                    <RequiredMessage maxWidth="auto">
                      <Image
                        src={errorIcon}
                        alt="warning"
                        className="workingHour__error-icon"
                      />{" "}
                      {inputListError[i].timeError}
                    </RequiredMessage>
                  </ErrorDiv>
                </GridRow>
              )}
            </React.Fragment>
          );
        })}
      </MarginBottom>
    </>
  );
};

AddEditWorkingHours.propTypes = {
  t: PropTypes.func.isRequired,
  setInputList: PropTypes.func.isRequired,
  setInputListError: PropTypes.func.isRequired,
  requiredTimeData: PropTypes.string,
  setRequiredTimeData: PropTypes.func.isRequired,
  inputList: PropTypes.array.isRequired,
  inputListError: PropTypes.array.isRequired,
  workingHours: PropTypes.array.isRequired,
};

AddEditWorkingHours.defaultProps = {
  requiredTimeData: "",
};

export default withTranslation()(AddEditWorkingHours);
